import PengeluaranService from '@/services/pengeluaran';
import { userHaveRoles } from "@/services/utilities"

export default {
	namespaced: true,
	state: {
	},

	getters: {
	},

	actions: {
		async getPengeluaran({ commit, state, getters, dispatch }, page) {
			try {
				let response
				if (userHaveRoles(["accountant"]) || userHaveRoles(["admin"]) || userHaveRoles(["entity"]) || userHaveRoles(["purchasing"])) {
					response = await PengeluaranService.getPengeluaranCompanyByCategoryId(page)
				} else {
					response = await PengeluaranService.getPengeluaranUserByCategoryId(page)
				}
				return response.data ? response.data.data : [];
			} catch (e) {
				console.log(e)
			}
		},
		async createPengeluaran({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PengeluaranService.createPengeluaran({
					...payload,
					type: 'PENGELUARAN'
				});
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updatePengeluaran({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PengeluaranService.updatePengeluaran(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updateStatusPengeluaran({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await PengeluaranService.updateStatusPengeluaran(payload.id, {
					...payload
				})
				return response
			} catch (e) {
				console.log(e);
			}
		},
		async deletePengeluaran({ commit, state, getters, dispatch }, id) {
			try {
				const response = await PengeluaranService.deletePengeluaran(id)
				return response
			} catch (e) {
			}
		},
		async filterPengeluaran({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await PengeluaranService.filterPengeluaran(payload)
				return response
			} catch (e) {
				console.log(e)
			}
		}
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
